/**
 * The Load control, and the honest statement of what the numbers are.
 *
 * The pulsing "LIVE" dot is gone deliberately. Nothing polls now, and a live
 * indicator over data pulled an hour ago is exactly the "stale rendered as
 * current" failure the rest of the board is built to avoid.
 */
import { useLoad } from '../api/load'
import { useRange } from '../api/range'
import { age } from './format'
import './LoadBar.css'

export function LoadBar() {
  const { loaded, loadedAt, load, refresh } = useLoad()
  const { ttlSeconds } = useRange()

  if (!loaded) {
    return (
      <div className="loadbar">
        <button type="button" className="load-btn" onClick={load}>Load data</button>
        <span className="load-note mono">
          nothing is fetched until you ask — the heaviest panels scan hundreds of
          millions of documents
        </span>
      </div>
    )
  }

  const ageSeconds = loadedAt ? (Date.now() - loadedAt.getTime()) / 1000 : 0
  return (
    <div className="loadbar">
      <button type="button" className="load-btn ghost" onClick={refresh}>Refresh</button>
      <span className="load-note mono">
        pulled {loadedAt?.toISOString().slice(11, 19)}Z
        {ageSeconds > 60 ? ` · ${age(ageSeconds)} ago` : ''}
        {' · '}held for 24h{ttlSeconds ? ` · server cache ${age(ttlSeconds)}` : ''}
      </span>
    </div>
  )
}
